<template>
  <div class="container">
    <div class="list">
      <NavGroup
        v-for="subSystemList in systemList"
        :key="subSystemList.title"
        :group="subSystemList"
      />
    </div>
  </div>
</template>

<script>
import { getUrls } from '@/api/url';
import NavGroup from '@/components/Navigation/Group.vue';

export default {
  components: { NavGroup },
  data() {
    return {
      systemList: null,
      isShowTips: false,
    };
  },
  created() {
    getUrls().then((data) => {
      this.systemList = data;
    });
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: auto;
  padding: 30px 30px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(30, 60, 150, 0.06);
}

</style>
